// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_bm-b";
export var colorBlue = "_bm-8";
export var colorDot = "_bm-0";
export var colorDotLarge = "_bm-2";
export var colorDotSmall = "_bm-1";
export var colorGreen = "_bm-7";
export var colorGrey = "_bm-3";
export var colorOrange = "_bm-5";
export var colorPink = "_bm-a";
export var colorPurple = "_bm-9";
export var colorRed = "_bm-4";
export var colorYellow = "_bm-6";